import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

// Modules
import session from "@/store/modules/session/index";
import alerts from "../store/modules/alerts/index";
import areasList from "@/store/modules/areasList/index";
import agronomic from "@/store/modules/agronomic/index";
import logs from "@/store/modules/logs/index";
import samples from "@/store/modules/samples/index";
import profile from "@/store/modules/profile/index";
import setPassword from "@/store/modules/setPassword/index";
import results from "@/store/modules/results/index";
import profit from "@/store/modules/profit/index";
import user from "@/store/modules/user/index";
import project from "@/store/modules/project/index";
import container from "@/store/modules/container/index";
import packageSolena from "@/store/modules/packageSolena/index";

export default new Vuex.Store({
  state: {
    loader: false,
    appBarOptions: {},
  },
  mutations: {
    SET_LOADER(state, value) {
      state.loader = value;
    },
    SET_APPBAR_OPTIONS(state, options) {
      state.appBarOptions = options;
    },
  },
  actions: {
    async uploadImage({ commit }, file) {
      try {
        const response = await axios.post(`samples/upload-image`, file);
        return response.data;
      } catch (e) {
        return 0;
      }
    },

    async uploadFile({ commit }, file) {
      try {
        const response = await axios.post(`samples/upload-file`, file);
        return response.data;
      } catch (e) {
        return 0;
      }
    },
  },
  modules: {
    alerts,
    session,
    areasList,
    agronomic,
    logs,
    samples,
    profile,
    setPassword,
    results,
    profit,
    user,
    project,
    container,
    packageSolena,
  },
});
